import { render, staticRenderFns } from "./B2bSaleDetails.vue?vue&type=template&id=66ce661a&scoped=true&"
import script from "./B2bSaleDetails.vue?vue&type=script&lang=ts&"
export * from "./B2bSaleDetails.vue?vue&type=script&lang=ts&"
import style0 from "./B2bSaleDetails.vue?vue&type=style&index=0&id=66ce661a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../backups/absys-worktrees/2026-09-12-colomer-web/src/web/AbsysERP.WebApi/ClientApp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ce661a",
  null
  
)

export default component.exports